<mat-card class="system-card">
	<mat-card-header>
		<mat-card-title>
			@if (state.ledgerPendingLoading()) {
				<mat-spinner diameter="18" class="me-2 d-inline-block"></mat-spinner>
			}
			Do rozliczenia (kasa) ({{ state.ledgerPending().length }})
		</mat-card-title>
	</mat-card-header>
	<mat-card-content>
		@if (state.ledgerPending().length > 0) {
			<div class="summary-row">
				<mat-form-field appearance="outline" class="display-only">
					<mat-label>Do potrącenia PLN</mat-label>
					<input matInput [value]="state.ledgerPendingTotals().pln | priceFormat" readonly tabindex="-1" />
				</mat-form-field>
				<mat-form-field appearance="outline" class="display-only">
					<mat-label>Do potrącenia EUR</mat-label>
					<input matInput [value]="state.ledgerPendingTotals().eur | priceFormat" readonly tabindex="-1" />
				</mat-form-field>
			</div>
		} @else if (!state.ledgerPendingLoading()) {
			<p class="empty-state">Brak nierozliczonych wpisów kasowych do końca wybranego miesiąca.</p>
		}
	</mat-card-content>
</mat-card>
